<template>
  <div id="app">
    <router-view /> <!-- Hier wird WelcomeHome oder LogIn geladen -->
  </div>
</template>

<script>
export default {};
</script>
